import { createReducer } from "@reduxjs/toolkit";
import { API_GET_ALL_GENERALPARAMETER, API_GET_ALL_GENERALPARAMETER_FAIL, API_GET_ALL_GENERALPARAMETER_SUCCESS } from "actions/generalParameter";

const initialState = {
	data: null,
	loading: false,
};

const generalParameters = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_GENERALPARAMETER]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_GENERALPARAMETER_FAIL]: (state, action) => {
		state.loading = false;
	},
	[API_GET_ALL_GENERALPARAMETER_SUCCESS]: (state, action) => {
		state.loading = false;
		state.data = action.payload.data;
	},
});

export default generalParameters;
